import { render, staticRenderFns } from "./Hero1Icon.vue?vue&type=template&id=f5005a1a&scoped=true"
import script from "./Hero1Icon.vue?vue&type=script&lang=ts"
export * from "./Hero1Icon.vue?vue&type=script&lang=ts"
import style0 from "./Hero1Icon.vue?vue&type=style&index=0&id=f5005a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5005a1a",
  null
  
)

export default component.exports